<template>
    <div i="keyboard" v-if="show_keyboard">
        <div class="mask" @click="closeKeyboard" :class="{'show-mask': show_keyboard_content}"></div>
        <!-- keyboard-active -->
        <div class="keyboard" @click.stop :class="{'keyboard-active': show_keyboard_content}">
            <div class="keyboard-head verticle-center"><strong>{{title}}</strong></div>
            <ul class="keyboard-password verticle-center">
                <li class="verticle-center flex-1"><i v-if="keyboardValue.length>=1"></i></li>
                <li class="verticle-center flex-1"><i v-if="keyboardValue.length>=2"></i></li>
                <li class="verticle-center flex-1"><i v-if="keyboardValue.length>=3"></i></li>
                <li class="verticle-center flex-1"><i v-if="keyboardValue.length>=4"></i></li>
                <li class="verticle-center flex-1"><i v-if="keyboardValue.length>=5"></i></li>
                <li class="verticle-center flex-1"><i v-if="keyboardValue.length>=6"></i></li>
            </ul>
            <div class="keyboard-content">
                <!-- <div class="keyboard-title">安全键盘</div> -->
                <ul class="keyboard-numbers">
                    <li class="verticle-center">
                        <div m="click" @click="chooseNum(1)" class="keyboard-number verticle-center flex-1">1</div>
                        <div m="click" @click="chooseNum(2)" class="keyboard-number verticle-center flex-1">2</div>
                        <div m="click" @click="chooseNum(3)" class="keyboard-number verticle-center flex-1">3</div>
                    </li>
                    <li class="verticle-center">
                        <div m="click" @click="chooseNum(4)" class="keyboard-number verticle-center flex-1">4</div>
                        <div m="click" @click="chooseNum(5)" class="keyboard-number verticle-center flex-1">5</div>
                        <div m="click" @click="chooseNum(6)" class="keyboard-number verticle-center flex-1">6</div>
                    </li>
                    <li class="verticle-center">
                        <div m="click" @click="chooseNum(7)" class="keyboard-number verticle-center flex-1">7</div>
                        <div m="click" @click="chooseNum(8)" class="keyboard-number verticle-center flex-1">8</div>
                        <div m="click" @click="chooseNum(9)" class="keyboard-number verticle-center flex-1">9</div>
                    </li>
                    <li class="verticle-center">
                        <div @click="closeKeyboard" class="keyboard-number verticle-center flex-1">取消</div>
                        <div m="click" @click="chooseNum(0)" class="keyboard-number verticle-center flex-1">0</div>
                        <div @click="deleteNum" class="keyboard-number verticle-center flex-1"></div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<style rel="stylesheet/scss" lang="scss" scoped>
    @import "../assets/sass/toola";

    [i="keyboard"] {
        position: fixed;
        height: 100%;
        z-index: 2000;
        width: 100%;
        top: 0;
        left: 0;
        .mask{
            position: absolute;
            bottom: 0;
            right: 0;
            left: 0;
            top: 0;
            pointer-events: none;
            -webkit-transition: opacity .2s ease-in;
            transition: opacity .2s ease-in;
            opacity: 0;
            background-color: rgb(0, 0, 0); 
        }
        .show-mask{
            z-index: 1500; 
            opacity: 0.4; 
            pointer-events: auto;
        }
        .keyboard{
            background-color: #f3f3f3;
            // background: rgba($color: #00935F, $alpha: 1);
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            z-index: 1502;
            padding-bottom: r(20px);
            -webkit-transform: translateY(100%);
            transform: translateY(100%);
            -webkit-transition: -webkit-transform .2s;
            transition: -webkit-transform .2s;
            transition: transform .2s;
            transition: transform .2s,-webkit-transform .2s;
            .keyboard-head{
                position: relative;
                height: r(100px);
                justify-content: center;
                font-size: r(30px);
                &:after {
                    content: "";
                    position: absolute;
                    z-index: 0;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                    border-bottom: 1px solid #bebebe;
                    -webkit-transform: scaleY(.5);
                    transform: scaleY(.5);
                    -webkit-transform-origin: 0 0;
                    transform-origin: 0 0;
                }
            }
            .keyboard-password{
                margin: r(30px) r(30px) r(20px);
                position: relative;
                background-color: #fff;
                border-radius: r(10px);
                overflow: hidden;
                &before {
                    content: "";
                    position: absolute;
                    z-index: 0;
                    top: 0;
                    left: 0;
                    width: 100%;
                    border-top: 1px solid #bebebe;
                    -webkit-transform: scaleY(.5);
                    transform: scaleY(.5);
                    -webkit-transform-origin: 0 0;
                    transform-origin: 0 0;
                }
                li{
                    position: relative;
                    height: r(96px);
                    justify-content: center;

                    i{
                        width: r(24px);
                        height: r(24px);
                        border-radius: 50%;
                        background-color: #000;
                        display: block;
                        transform: scale(.5,.5);
                        -webkit-transform: scale(.5,.5);
                        transform-origin: center center;
                        -webkit-transform-origin: center center;
                    }
                    &:not(:last-child){
                        &:after{
                            content: "";
                            width: 1px;
                            height: 50%;
                            position: absolute;
                            right: 0;
                            top: 25%;
                            background-color: #d9d9d9;
                            -webkit-transform: scaleX(.5);
                            transform: scaleX(.5);
                        }
                    }
                }
            }
            .keyboard-content{
                .keyboard-numbers{
                    color: #686868;
                    padding: 0 r(20px);
                    li{
                        position: relative;
                        
                        .keyboard-number{
                            position: relative;
                            background-color: #ffffff;
                            height: r(100px);
                            font-size: r(38px);
                            justify-content: center;
                            margin: r(10px);
                            border-radius: r(10px);
                            &:before {
                                // content: "";
                                // position: absolute;
                                // z-index: 0;
                                // top: 0;
                                // left: 0;
                                // width: 100%;
                                // border-top: 1px solid #d9d9d9;
                                // -webkit-transform: scaleY(.5);
                                // transform: scaleY(.5);
                                // -webkit-transform-origin: 0 0;
                                // transform-origin: 0 0;
                            }
                            &:not(:last-child){
                                &::after {
                                    // content: "";
                                    // position: absolute;
                                    // z-index: 0;
                                    // top: 0;
                                    // right: 0;
                                    // height: 100%;
                                    // border-right: 1px solid #d9d9d9;
                                    // -webkit-transform: scaleX(.5);
                                    // transform: scaleX(.5);
                                    // -webkit-transform-origin: 0 0;
                                    // transform-origin: 0 0;
                                }
                            }
                        }
                        &:last-child{
                            .keyboard-number{
                                &:nth-last-child(3){
                                    background-color: #FF7900;
                                    color: #fff;
                                    font-size: r(34px);
                                }
                                &:last-child{
                                    background-color: #FF7900;
                                    color: #fff;
                                    &:after {
                                        font-family: YDUI-INLAY;
                                        content: "\E609";
                                        font-size: r(52px);
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        .keyboard-active{
            -webkit-transform: translate3d(0,0,0);
            transform: translate3d(0,0,0);
        }
    }
</style>
<script>

    export default {
        name: 'baseKeyboard',
        data() {
            return {
                show_keyboard: false,
                show_keyboard_content: false,
                keyboardValue: []
            }
        },
        props: {
            value: {
                default: false
            },
            callback: {
                default: function(params){ }
            },
            title: {
                type: String,
                default:'输入数字密码'
            }
        },
        model:{
            prop: 'value',
            event: 'changeValue'
        },
        methods: {
            deleteNum(){
                let that = this;
                that.keyboardValue.splice(that.keyboardValue.length-1,1);
            },
            chooseNum(val){
                let that = this;
                that.keyboardValue.push(val);
                if (that.keyboardValue.length>=6) {
                    that.keyboardCallback();
                }
            },
            keyboardCallback(){
                let that = this;
                if (typeof that.callback) {
                    that.callback(that.keyboardValue.join(''));
                    that.keyboardValue = [];
                }
                // that.$emit('callback', that.keyboardValue.join(''));
                // that.closeKeyboard();
            },
            closeKeyboard(){
                let that = this;
                // that.value = false;
                that.keyboardValue = [];
                that.$emit('changeValue',false);
            }
        },
        watch: {
            value(val){
                let that = this;
                if (val) {
                    that.show_keyboard = val;
                    setTimeout(()=>{
                        that.show_keyboard_content = val;
                    },0)
                } else {
                    that.show_keyboard_content = val;
                    setTimeout(()=>{
                       that.show_keyboard = val;
                    },200)
                }
            }
        },
        components: {

        },
        filters: {

        },
        mounted() {
            let that = this;
            console.log(typeof that.callback);
        }
    }
</script>


// WEBPACK FOOTER //
// Keyboard.vue?40868d69